import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import React from 'react';
import { Waypoint } from 'react-waypoint';
import { LoadingState } from '@atlassian/notification-types/types';
import { ErrorBoundarySuspense } from '../../../common/ui/error-boundary-suspense';
import NotificationItemSkeleton from '../../../common/ui/notification-item-skeleton';
import { TextSkeleton } from '../../../common/ui/text-skeleton';
import { NoMoreToLoad } from './no-more-to-load';
import { NoMoreNotifications } from './no-notifications';
import { PlaceholderSpacing } from './styled';
import { TotalFailure } from './total-failure';
var ShortcutsProTip = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackChunkName: "@atlaskit-internal_notification-list/pro-tip" */
  '../../../common/ui/shortcut-pro-tip');
});
export var LoadMoreWaypoint = function LoadMoreWaypoint(_ref) {
  var listSize = _ref.listSize,
    fetchState = _ref.fetchState,
    canLoadMore = _ref.canLoadMore,
    fetchData = _ref.fetchData,
    readStateFilter = _ref.readStateFilter;
  var skeletonsToRender = listSize >= 6 ? 1 : 6 - listSize;
  switch (fetchState) {
    case LoadingState.ERROR:
      {
        return /*#__PURE__*/React.createElement(TotalFailure, {
          notificationsRendered: listSize
        });
      }
    case LoadingState.INITIAL:
    case LoadingState.LOADING:
      {
        return /*#__PURE__*/React.createElement(React.Fragment, null, listSize === 0 && /*#__PURE__*/React.createElement(TextSkeleton, {
          width: '50px',
          marginBottom: "8px"
        }), _toConsumableArray(Array(skeletonsToRender)).map(function (_, index) {
          return /*#__PURE__*/React.createElement(NotificationItemSkeleton, {
            key: index
          });
        }));
      }
    case LoadingState.COMPLETE:
      {
        if (canLoadMore) {
          return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Waypoint, {
            key: "load-more",
            onEnter: fetchData
          }, /*#__PURE__*/React.createElement(PlaceholderSpacing, {
            "data-testid": "load-more-waypoint"
          })), /*#__PURE__*/React.createElement(NotificationItemSkeleton, null));
        }
        if (listSize === 0) {
          return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(NoMoreNotifications, {
            readStateFilter: readStateFilter,
            viewedCount: listSize
          }), /*#__PURE__*/React.createElement(ErrorBoundarySuspense, {
            subjectId: "shortcuts-pro-tip",
            loadingFallback: /*#__PURE__*/React.createElement(React.Fragment, null)
          }, /*#__PURE__*/React.createElement(ShortcutsProTip, null)));
        }
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(NoMoreToLoad, {
          readStateFilter: readStateFilter,
          viewedCount: listSize
        }), /*#__PURE__*/React.createElement(ErrorBoundarySuspense, {
          subjectId: "shortcuts-pro-tip",
          loadingFallback: /*#__PURE__*/React.createElement(React.Fragment, null)
        }, /*#__PURE__*/React.createElement(ShortcutsProTip, null)));
      }
    default:
      {
        return null;
      }
  }
};